/**
 * Chama a função de exibição|criação do carrossel caso o botão horus
 * seja clicado
 */
function AnexoRelatorio() {
  $('#attach-file').on('click', openFileUpload);
  $('input[name=anexo]').on('change', uploadFile);
  $('#remove-attachment').on('click', deleteFile);
}

function openFileUpload() {
  $('input[name=anexo]').trigger('click');
}

function uploadFile() {
  $('#form-anexo-relatorio').trigger('submit');
}

function deleteFile() {
  $('#form-anexo-relatorio').trigger('submit');
}

module.exports = {
  init: AnexoRelatorio,
  url: /\/relatorios\/\d+/
}
